

<an-heart-icon *ngIf="!newVdpIcon" [id]="id" [newIcon]="newIcon" [newVdpIcon]="newVdpIcon" [iconWidth]="iconWidth" [iconHeight]="iconHeight" [state]="saved" [ariaLabel]="ariaLabel" (onClickHeartIcon)="clickHeartIcon()"></an-heart-icon>

<an-vdp-heart-icon *ngIf="newVdpIcon" [id]="id" [newIcon]="newIcon" [newVdpIcon]="newVdpIcon" [iconWidth]="iconWidth" [iconHeight]="iconHeight" [state]="saved" [ariaLabel]="ariaLabel" [vin]="vin" [isLoggedIn]="isLoggedIn"  (onClickHeartIcon)="clickHeartIcon()"></an-vdp-heart-icon>
